class FormSubmit extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            "contactForm": ".contact-form",
            "signupForm": ".signup-form"
        }
    }

    connectedCallback() {
        this.elements = {
            "contactForm": this.querySelector(this.selectors.contactForm),
            "signupForm": this.querySelector(this.selectors.signupForm)
        }
        if (this.elements.contactForm) {
            this.elements.contactForm.addEventListener("submit", this.submitForm.bind(this));
        }
        if (this.elements.signupForm) {
            this.elements.signupForm.addEventListener("submit", this.submitKlaviyo.bind(this));
        }
    }

    submitForm(event) {
        event.preventDefault();
        const form = event.target;
        const submitButton = form.querySelector("button[type='submit']");
        const messageBox = form.querySelector(".contact-form-msg");
        const formData = new FormData(form);
        
        submitButton.disabled = true;
        submitButton.textContent = "SUBMITTING...";

        fetch("/contact", {
            method: "POST",
            body: formData,
            headers: {
                "X-Requested-With": "XMLHttpRequest"
            },
        })
        .then(response => response.text())
        .then(data => {
            if (data.includes("form-post-success")) {
                messageBox.textContent = "Your message has been sent successfully!";
                messageBox.classList.remove("hidden", "text-red-600");
                messageBox.classList.add("text-green-600");
                form.reset();
            } else {
                messageBox.textContent = "Something went wrong. Please try again.";
                messageBox.classList.remove("hidden", "text-green-600");
                messageBox.classList.add("text-red-600");
            }
        })
        .catch(() => {
            messageBox.textContent = "Something went wrong. Please try again.";
            messageBox.classList.remove("hidden", "text-green-600");
            messageBox.classList.add("text-red-600");
        })
        .finally(() => {
            submitButton.disabled = false;
            submitButton.textContent = "SUBMIT";
        });
    }

    async submitKlaviyo(event) {
        event.preventDefault();
        this.elements.signupForm.setAttribute("loading", "")
        const form = event.target;
        const formData = new FormData(form);
        let KLAVIYO_API_KEY = "Wqp3bU"
        let listId = "RH8jLy"
        const data = {
            email: formData.get("email")
        }

        if (!data.email || KLAVIYO_API_KEY === undefined || listId === undefined) {
            this.elements.signupForm.removeAttribute("loading");
            this.elements.signupForm.setAttribute("error", "Error Data format");
            return;
        }

        const options = {
            method: 'POST',
            headers: { revision: '2024-07-15', 'content-type': 'application/json' },
            body: JSON.stringify({
                data: {
                    type: 'subscription',
                    attributes: {
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email: data.email,
                                }
                            }
                        }
                    },
                    relationships: { list: { data: { type: 'list', id: listId } } }
                }
            })
        };

        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_API_KEY}`, options);

        if (res.ok) {
            this.elements.signupForm.removeAttribute("loading");
            this.elements.signupForm.setAttribute("state", "success");
            const inputLabel = this.elements.signupForm.querySelector("label input#email_subscribe");
            this.removeState = () => {
                this.elements.signupForm.removeAttribute("state");
                inputLabel.removeEventListener("focus", this.removeState);
            }
            inputLabel.addEventListener("focus", this.removeState);
        } else {
            this.elements.signupForm.removeAttribute("loading");
            this.elements.signupForm.setAttribute("error", res.statusText);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    customElements.define("form-submit", FormSubmit);
});